export default __webpack_public_path__ + "static/mouse-0a4eda187c485a3058ca5ee9132eedc5.png";